import React from "react";

export const About = () => {
  return (
    <div className="about-info">
      <p>
        Jeetpal's Todolist is a react based project. I created this to revise my web development skills. Moreover, I use todo list in my daily routine, that is I wanted to created my own todo list app, in which I can customize things according to me. This app uses local storage to store the add tasks.
      </p>
    </div>
  );
};
